import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Line, Circle } from 'rc-progress';
import _ from 'lodash';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import Shuffle from 'react-shuffle';
import CircularProgress from 'material-ui/CircularProgress';
import Dialog from 'material-ui/Dialog';
import { ASSET_PREFIX } from '../config/constants';

import { changeState, createQuiz, updateDashboard } from '../actions/index';

import QbankButton from '../components/QbankButton';

import greyWatch from '../images/stopwatch-grey.png';
import progUp from '../images/progress-up.png';
import progDown from '../images/progress-down.png';
import megaphone from '../images/megaphone.png';

import '../styles/Dashboard.css';

const pct = (a, b) =>
  isNaN(Math.round(100 * (a / b)))
    ? 0
    : !isFinite(Math.round(100 * (a / b))) ? 100 : Math.round(100 * (a / b));
const getPercentColor = p =>
  p < 71 ? '#FF7065' : p < 86 ? '#DFDF56' : '#95BF5E';
const monthDays = (month, year) =>
  [
    31,
    new Date(year, 2, 0).getDate() === 29 ? 29 : 28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ][month];
const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];
const dayNames = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
];

const graphMapFunc = p => {
  const map = {};

  p.forEach(d => {
    const date = new Date(d.date);
    const year = date.getYear();
    const month = date.getMonth();
    const day = date.getDate();

    if (map[year] === undefined) {
      map[year] = {};
    }
    if (map[year][month] === undefined) {
      map[year][month] = {};
    }
    map[year][month][day] = d;
  });

  return map;
};

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.init = props => {
      const temp = props.stats.progress[0]
        ? new Date(props.stats.progress[0].date)
        : new Date();
      this.setState({ selectedMonth: [temp.getYear(), temp.getMonth()] });
    };

    this.state = {
      selectedMonth: null,
      selectedProfIndex: 0,
      selectedOSProfIndex: 0,
      selectedTimeRangeIndex: 0,
      barProps: null,
      organsAlpha: true,
      loading: false,
      quizTagId: null,
      organAvg: true,
      lastQuizPercent: this.props.params.fromQuiz ? 0 : undefined,
      infoDialogOpen: false
    };

    this.componentMounted = true;
  }

  componentWillMount() {
    if (
      !this.state.selectedMonth &&
      this.props.stats &&
      this.props.stats.quizzes
    ) {
      this.init(this.props);
    }
  }

  componentDidMount() {
    if (this.props.params.fromQuiz) {
      window.setTimeout(() => {
        this.setState({
          lastQuizPercent: pct(
            this.props.stats.quizzes[0].correctCount,
            this.props.stats.quizzes[0].totalCount
          )
        });
      }, 100);
    }
  }

  componentWillReceiveProps(next) {
    if (!this.state.selectedMonth && next.stats && next.stats.quizzes) {
      this.init(next);
    }
  }

  componentWillUnmount() {
    this.componentMounted = false;
  }

  render() {
    const ctaGroup = this.props.product
      ? require(`../images/${ASSET_PREFIX[this.props.product]}-icons-3@3x.png`)
      : null;
    const graph = this.props.product
      ? require(`../images/${ASSET_PREFIX[this.props.product]}-graph@3x.png`)
      : null;
    const {
      overall,
      progress,
      quizzes,
      loading,
      answeredQuestions,
      totalQuestionCount
    } = this.props.stats ? this.props.stats : {};

    if (!loading) {
      const graphMap =
        progress && progress.length ? graphMapFunc(progress) : null;
      const overallPercent = overall
        ? pct(overall.correctCount, overall.totalCount)
        : null;
      const lastQuizPercent =
        this.state.lastQuizPercent !== undefined
          ? this.state.lastQuizPercent
          : quizzes && quizzes.length
            ? pct(quizzes[0].correctCount, quizzes[0].totalCount)
            : null;
      const percentChange =
        quizzes && quizzes.length && quizzes[1]
          ? pct(
              lastQuizPercent -
                pct(quizzes[1].correctCount, quizzes[1].totalCount),
              pct(quizzes[1].correctCount, quizzes[1].totalCount)
            )
          : null;
      const temp = this.props.stats
        ? this.state.organsAlpha
          ? this.props.tags
          : _.cloneDeep(this.props.tags).sort((a, b) => {
              const aVal = a.accountCorrectCount / a.accountTotalCount;
              const bVal = b.accountCorrectCount / b.accountTotalCount;
              return aVal === bVal || (isNaN(aVal) && isNaN(bVal))
                ? a.title < b.title ? -1 : 1
                : isNaN(aVal) ? 1 : isNaN(bVal) ? -1 : aVal - bVal;
            })
        : [];
      const tags = Array.isArray(temp)
        ? temp.map(t =>
            Object.assign(t, {
              average:
                this.props.stats.professions[this.state.selectedOSProfIndex]
                  .organSystems[t.id].correctCount /
                this.props.stats.professions[this.state.selectedOSProfIndex]
                  .organSystems[t.id].totalCount
            })
          )
        : [];
      const selectedProfPercent =
        this.props.stats &&
        this.props.stats.professions[this.state.selectedProfIndex]
          ? this.props.stats.professions[this.state.selectedProfIndex]
              .correctCount /
            this.props.stats.professions[this.state.selectedProfIndex]
              .totalCount
          : null;
      const compareBarHeight = isNaN(selectedProfPercent)
        ? 0
        : selectedProfPercent * 100;

      const isMobile = window.innerWidth < 1000;
      const isSmallMobile = window.innerWidth < 400;

      const styles = {
        quizButton: isMobile
          ? {
              width: '220px',
              height: '40px',
              fontSize: '13px',
              margin: 0
            }
          : {
              width: '280px',
              height: '50px',
              fontSize: '15px',
              margin: 0
            }
      };

      const actions = [
        <QbankButton
          label="OK, GOT IT"
          style={{
            width: '140px',
            height: '35px',
            fontSize: '13px'
          }}
          onClick={() => this.setState({ infoDialogOpen: false })}
        />
      ];
      return (
        <div className="dash-wrapper">
          {quizzes && quizzes.length ? (
            <div className="dashboard">
              {ASSET_PREFIX[this.props.product] === 'pa' &&
              Date.now() < new Date('12-6-2018') ? (
                <div id="pa-banner">
                  <img src={megaphone} />
                  <span>
                    Attention PA All Stars: A new batch of questions has been
                    added to the AAPA PANCE/PANRE Qbank. You will not lose any
                    progress on questions you've already answered but you may
                    notice a change in your total progress. Enjoy!
                  </span>
                </div>
              ) : null}
              <div className="dash-title-row">
                <p className="hide hide-on-mobile">How is this scored?</p>
                <p className="qbank-title">QBANK DASHBOARD</p>
                <p
                  className="dash-info hide-on-mobile"
                  onTouchTap={() => this.setState({ infoDialogOpen: true })}
                >
                  How is this scored?
                </p>
              </div>
              <div className="dashboard-content">
                <p className="question-breakdown">
                  You've answered
                  <span>{` ${
                    answeredQuestions.length
                  } out of ${totalQuestionCount}`}</span>{' '}
                  total questions correctly.
                </p>
                <div className="progress-content">
                  <div className="score-column">
                    <div className="score-card card">
                      <p className="score-card-header card-header">
                        OVERALL SCORE
                      </p>
                      <div className="score-card-content">
                        <div className="score-circle">
                          <Circle
                            percent={overallPercent}
                            strokeWidth="10"
                            trailWidth="10"
                            strokeLinecap="square"
                            strokeColor={getPercentColor(overallPercent)}
                          />
                        </div>
                        <p
                          className="circle-percent"
                          style={{ color: getPercentColor(overallPercent) }}
                        >
                          {overallPercent}%
                        </p>
                        <div className="score-text-col">
                          <div className="score-text-section">
                            <p className="score-text">{`${
                              overall.correctCount
                            } / ${overall.totalCount} CORRECT`}</p>
                            <p className="score-text">{`${
                              overall.sessions
                            } QUIZ SESSIONS`}</p>
                            <p className="score-text">{`${Math.floor(
                              overall.time / 3600
                            )}hr ${
                              Math.floor((overall.time % 3600) / 60) < 10
                                ? '0'.concat(
                                    Math.floor((overall.time % 3600) / 60)
                                  )
                                : Math.floor((overall.time % 3600) / 60)
                            }min`}</p>
                          </div>
                          <div className="score-text-section">
                            <p className="time-text">AVG TIME</p>
                            <p className="time-text">PER QUESTION:</p>
                            <div className="time-row">
                              <img alt="" src={greyWatch} />
                              {(() => {
                                const secondsPerQuestion = Math.round(
                                  overall.time / overall.totalCount
                                );
                                const minutesPer = Math.floor(
                                  secondsPerQuestion / 60
                                );
                                return (
                                  <p className="time-text">{`${minutesPer} min ${
                                    secondsPerQuestion % 60 < 10
                                      ? '0'.concat(
                                          (secondsPerQuestion % 60).toString()
                                        )
                                      : secondsPerQuestion % 60
                                  } sec`}</p>
                                );
                              })()}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="score-card card">
                      <p className="score-card-header card-header">
                        LAST QUIZ <span>|</span>
                        {(() => {
                          const lastQuizDate = new Date(progress[0].date);
                          return (
                            <span>{`${dayNames[lastQuizDate.getDay()]}, ${
                              monthNames[lastQuizDate.getMonth()].length > 4
                                ? monthNames[lastQuizDate.getMonth()].slice(
                                    0,
                                    3
                                  )
                                : monthNames[lastQuizDate.getMonth()]
                            } ${
                              lastQuizDate.getDate() < 10
                                ? '0'.concat(lastQuizDate.getDate())
                                : lastQuizDate.getDate()
                            }`}</span>
                          );
                        })()}
                      </p>
                      <div className="score-card-content change-card-content">
                        <div className="score-circle today-circle">
                          <Circle
                            percent={lastQuizPercent}
                            strokeWidth="10"
                            trailWidth="10"
                            strokeLinecap="square"
                            strokeColor={getPercentColor(lastQuizPercent)}
                          />
                        </div>
                        <p
                          className="circle-percent today-percent"
                          style={{ color: getPercentColor(lastQuizPercent) }}
                        >
                          {lastQuizPercent}%
                        </p>
                        <div className="change-text-col">
                          <div className="score-text-section">
                            <p className="score-text">{`${
                              quizzes[0].correctCount
                            } / ${quizzes[0].totalCount} CORRECT`}</p>
                            <p className="score-text">{`${Math.floor(
                              quizzes[0].time / 3600
                            )}hr ${
                              Math.round((quizzes[0].time % 3600) / 60) < 10
                                ? '0'.concat(
                                    Math.round((quizzes[0].time % 3600) / 60)
                                  )
                                : Math.round((quizzes[0].time % 3600) / 60)
                            }min`}</p>
                          </div>
                          <div className="score-text-section change-section">
                            <div
                              className="icon-percent-col"
                              style={{
                                color:
                                  percentChange >= 0 ? '#95BF5E' : '#FF7065'
                              }}
                            >
                              <img
                                alt=""
                                src={percentChange >= 0 ? progUp : progDown}
                              />
                              <p className="change-percent">{`${
                                percentChange >= 0 ? '+' : ''
                              }${
                                percentChange !== null ? percentChange : 0
                              }%`}</p>
                            </div>
                            <div className="change-text">
                              <p>
                                {percentChange >= 0
                                  ? 'Keep it up!'
                                  : 'Time to get at it!'}
                              </p>
                              <p>
                                You're{' '}
                                {percentChange === null || percentChange >= 0
                                  ? 'up'
                                  : 'down'}{' '}
                                {percentChange !== null ? percentChange : 0}%
                                from last time.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="progress-graph card">
                    <p className="progress-header card-header">MY PROGRESS</p>
                    <div className="dropdown-row">
                      <div className="dropdown">
                        <p className="dropdown-label">MONTH</p>
                        <DropDownMenu
                          className="dropdown-menu"
                          value={`${this.state.selectedMonth[0]}-${
                            this.state.selectedMonth[1]
                          }`}
                          onChange={(e, i, val) => {
                            this.setState({
                              selectedMonth: val.split('-'),
                              selectedTimeRangeIndex: i
                            });
                          }}
                          selectedMenuItemStyle={{ color: '#95BF5E' }}
                        >
                          {_.flatten(
                            Object.keys(graphMap).map(year =>
                              Object.keys(graphMap[year]).map(month => (
                                <MenuItem
                                  value={`${year}-${month}`}
                                  primaryText={`${
                                    monthNames[month]
                                  } 20${year.slice(1)}`}
                                />
                              ))
                            )
                          ).reverse()}
                        </DropDownMenu>
                      </div>
                      <div className="dropdown">
                        <p className="dropdown-label">COMPARE TO AVG</p>
                        <DropDownMenu
                          className="dropdown-menu"
                          value={
                            this.props.stats.professions[
                              this.state.selectedProfIndex
                            ].title
                          }
                          onChange={(e, i) => {
                            this.setState({ selectedProfIndex: i });
                          }}
                          selectedMenuItemStyle={{ color: '#95BF5E' }}
                        >
                          {this.props.stats.professions.map(prof => (
                            <MenuItem
                              value={prof.title}
                              primaryText={prof.title}
                            />
                          ))}
                        </DropDownMenu>
                      </div>
                    </div>
                    <div className="graph">
                      <div className="y-axis-label">100%</div>
                      <div className="graph-main">
                        <div className="graph-bar-section">
                          {_.range(31).map(n => (
                            <div className="graph-bar">
                              <div
                                className="graph-bar-bg"
                                style={
                                  n >=
                                  monthDays(
                                    this.state.selectedMonth[1],
                                    `2${this.state.selectedMonth[0]}`
                                  )
                                    ? {
                                        height: 0,
                                        backgroundColor: 'white'
                                      }
                                    : {}
                                }
                              />
                              <div
                                className="graph-bar-cb"
                                style={Object.assign(
                                  compareBarHeight === 0
                                    ? { borderTop: 'none' }
                                    : {},
                                  { height: `${compareBarHeight}%` }
                                )}
                              />
                              <div
                                className="graph-bar-fg"
                                style={{
                                  height: `${
                                    graphMap[this.state.selectedMonth[0]][
                                      this.state.selectedMonth[1]
                                    ][n + 1]
                                      ? pct(
                                          graphMap[this.state.selectedMonth[0]][
                                            this.state.selectedMonth[1]
                                          ][n + 1].correctCount,
                                          graphMap[this.state.selectedMonth[0]][
                                            this.state.selectedMonth[1]
                                          ][n + 1].totalCount
                                        )
                                      : 0
                                  }%`,
                                  backgroundColor: getPercentColor(
                                    graphMap[this.state.selectedMonth[0]][
                                      this.state.selectedMonth[1]
                                    ][n + 1]
                                      ? pct(
                                          graphMap[this.state.selectedMonth[0]][
                                            this.state.selectedMonth[1]
                                          ][n + 1].correctCount,
                                          graphMap[this.state.selectedMonth[0]][
                                            this.state.selectedMonth[1]
                                          ][n + 1].totalCount
                                        )
                                      : 0
                                  )
                                }}
                              />
                            </div>
                          ))}
                          {compareBarHeight ? (
                            <div
                              className="compare-container"
                              style={{ bottom: `${compareBarHeight - 5}%` }}
                            >
                              <div
                                className="compare-text"
                                style={
                                  compareBarHeight === 0 ? { opacity: 0 } : {}
                                }
                              >
                                <div
                                  className="compare-percent"
                                  style={{
                                    color: getPercentColor(
                                      selectedProfPercent * 100
                                    )
                                  }}
                                >
                                  {(isNaN(selectedProfPercent)
                                    ? 0
                                    : !isFinite(selectedProfPercent)
                                      ? 100
                                      : selectedProfPercent * 100
                                  ).toFixed(0)}%
                                </div>
                                <div className="compare-label hide-on-mobile">
                                  Peer
                                </div>
                                <div className="compare-label hide-on-mobile">
                                  Group
                                </div>
                                <div className="compare-label">Avg</div>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="graph-label-section">
                      <p className="axis-label hide-on-mobile">DAY</p>
                      <div className="graph-labels">
                        {_.range(
                          monthDays(
                            this.state.selectedMonth[1],
                            `2${this.state.selectedMonth[0]}`
                          )
                        ).map(n => (
                          <p
                            className="tick-label"
                            style={
                              !graphMap[this.state.selectedMonth[0]][
                                this.state.selectedMonth[1]
                              ][n + 1]
                                ? { color: '#B7B7B7' }
                                : null
                            }
                          >
                            {n + 1 < 10 ? (
                              <span>
                                <span className="hide">0</span>
                                {n + 1}
                              </span>
                            ) : (
                              n + 1
                            )}
                          </p>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="prompt-container card">
                <img alt="" src={ctaGroup} />
                <QbankButton
                  label={
                    this.props.isTrial ? 'START FREE TRIAL' : 'START NEW QUIZ'
                  }
                  style={styles.quizButton}
                  onClick={() => this.props.changeState('init', { skip: true })}
                />
              </div>
              <div className="organ-stats card">
                <p className="card-header organ-header">
                  PERFORMANCE BY ORGAN SYSTEM
                </p>
                <div className="main-organ-stats">
                  <div className="organ-button-row">
                    <div className="os-sort-col">
                      <div className="organize-selection">
                        <div
                          className={`org-select-button org-sort-button${
                            this.state.organsAlpha ? ' sort-selected' : ''
                          }`}
                          style={
                            this.state.organsAlpha
                              ? { color: 'white', backgroundColor: '#A1A0A0' }
                              : {
                                  color: '#848484',
                                  backgroundColor: 'white'
                                }
                          }
                          onClick={() => this.setState({ organsAlpha: true })}
                        >
                          <span>ALPHABETICAL</span>
                        </div>
                        <div
                          className={`org-select-button org-sort-button${
                            !this.state.organsAlpha ? ' sort-selected' : ''
                          }`}
                          style={
                            !this.state.organsAlpha
                              ? { color: 'white', backgroundColor: '#A1A0A0' }
                              : {
                                  color: '#848484',
                                  backgroundColor: 'white'
                                }
                          }
                          onClick={() => this.setState({ organsAlpha: false })}
                        >
                          <span>WEAK TO STRONG</span>
                        </div>
                      </div>
                    </div>
                    <div className="dropdown">
                      <p className="dropdown-label">COMPARE TO AVG</p>
                      <DropDownMenu
                        className="dropdown-menu"
                        value={
                          this.props.stats.professions[
                            this.state.selectedOSProfIndex
                          ].title
                        }
                        onChange={(e, i) => {
                          this.setState({ selectedOSProfIndex: i });
                        }}
                        selectedMenuItemStyle={{ color: '#95BF5E' }}
                      >
                        {this.props.stats.professions.map(prof => (
                          <MenuItem
                            value={prof.title}
                            primaryText={prof.title}
                          />
                        ))}
                      </DropDownMenu>
                    </div>
                  </div>
                  <div className="organ-list">
                    <Shuffle duration={750}>
                      {tags.map((tag, i) => {
                        const avg = isNaN(tag.average) ? 0 : tag.average;
                        return (
                          <div key={tag.id}>
                            <div
                              className={`dash-organ${i === 0 ? ' first' : ''}`}
                            >
                              <img
                                alt=""
                                className="hide-on-mobile"
                                src={tag.imageUrl}
                              />
                              <div className="organ-title-wrapper">
                                <p className={`dash-organ-title dash-organ-title-${ASSET_PREFIX[this.props.product]}`}>{tag.title}</p>
                                <p className="hide-on-mobile abem-percent">{`${
                                  ASSET_PREFIX[this.props.product] === 'peds'
                                    ? 'ABP'
                                    : ASSET_PREFIX[this.props.product] === 'pa'
                                      ? 'PANCE'
                                      : 'ABEM'
                                } ${tag.abemPercent}%`}</p>
                                { ASSET_PREFIX[this.props.product] === 'pa' &&
                                  <p className="hide-on-mobile abem-percent">
                                    {`PANRE ${tag.testPercent2}%`}
                                  </p>
                                }
                                <p className="dash-organ-completed">
                                  <span>{tag.uniqueCompleted}</span> out of
                                  <span>{tag.questionCount}</span> correct
                                </p>
                              </div>
                              <div className="organ-progress-container">
                                <Line
                                  percent={pct(
                                    tag.accountCorrectCount,
                                    tag.accountTotalCount
                                  )}
                                  className="dash-organ-bar"
                                  strokeWidth="8"
                                  trailWidth="8"
                                  strokeLinecap="square"
                                  strokeColor={getPercentColor(
                                    pct(
                                      tag.accountCorrectCount,
                                      tag.accountTotalCount
                                    )
                                  )}
                                />
                                <div
                                  style={Object.assign(
                                    { left: `${100 * tag.average}%` },
                                    avg === 0 ? { opacity: 0 } : {}
                                  )}
                                  className={`organ-avg-marker`}
                                >
                                  <span className="organ-avg-bar" />
                                  <p className="organ-avg-percent">{`Avg: ${parseInt(
                                    avg * 100,
                                    10
                                  )}%`}</p>
                                </div>
                              </div>
                              <p
                                style={{
                                  color: tag.accountTotalCount
                                    ? getPercentColor(
                                        pct(
                                          tag.accountCorrectCount,
                                          tag.accountTotalCount
                                        )
                                      )
                                    : '#777'
                                }}
                                className="dash-organ-percent"
                              >{`${
                                isNaN(
                                  pct(
                                    tag.accountCorrectCount,
                                    tag.accountTotalCount
                                  )
                                )
                                  ? 0
                                  : tag.accountTotalCount
                                    ? pct(
                                        tag.accountCorrectCount,
                                        tag.accountTotalCount
                                      )
                                    : '--'
                              }%`}</p>
                              {this.state.loading &&
                              tag.id === this.state.quizTagId ? (
                                <CircularProgress
                                  size={60}
                                  thickness={7}
                                  color="#95BF5E"
                                  style={{ marginRight: '3em' }}
                                />
                              ) : (
                                <QbankButton
                                  className={`${
                                    this.props.isTrial ? '' : 'secondary'
                                  } quiz-organ-button${
                                    !this.state.loading ? ' button-hover' : ''
                                  }${
                                    isSmallMobile
                                      ? ' small-mobile-dash-button'
                                      : isMobile ? ' mobile-dash-button' : ''
                                  }`}
                                  label="QUIZ THIS TOPIC"
                                  disabled={this.props.isTrial}
                                  wrapperClassName={`${
                                    isSmallMobile
                                      ? 'small-mobile-dash-button-wrapper'
                                      : 'mobile-dash-button-wrapper'
                                  }`}
                                  style={
                                    this.state.loading &&
                                    tag.id !== this.state.quizTagId
                                      ? {
                                          opacity: 0,
                                          cursor: 'default'
                                        }
                                      : {
                                          width: '140px',
                                          height: '35px',
                                          fontSize: '13px'
                                        }
                                  }
                                  onClick={
                                    !this.state.loading
                                      ? () => {
                                          this.setState({
                                            loading: true,
                                            quizTagId: tag.id
                                          });
                                          this.props.changeState('init', {
                                            fromDash: [tag.id]
                                          });
                                        }
                                      : null
                                  }
                                />
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </Shuffle>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="dash-no-data">
              <div className="dashboard">
                <p className="qbank-title">QBANK DASHBOARD</p>
                <div className="no-data-prompt">
                  <p>
                    Welcome to the Qbank Dashboard where you'll be able to track
                    your progress.
                  </p>
                </div>
                <div className="prompt-container card">
                  <img alt="" src={ctaGroup} />
                  <QbankButton
                    className="dash-start-new"
                    label={
                      this.props.isTrial ? 'START FREE TRIAL' : 'START NEW QUIZ'
                    }
                    style={styles.quizButton}
                    onClick={() =>
                      this.props.changeState('init', { skip: true })
                    }
                  />
                </div>
              </div>
            </div>
          )}
          <Dialog
            actions={actions}
            modal={true}
            contentStyle={{ paddingBottom: 0 }}
            open={this.state.infoDialogOpen}
            className="dash-info-wrapper"
          >
            <div className="dash-info-dialog">
              <img alt="" src={graph} />
              <p>
                The progress score is the total number of correctly answered
                question items divided by your total number of answer attempts,
                averaged over time.
              </p>
            </div>
          </Dialog>
        </div>
      );
    } else {
      return (
        <div className="dash-wrapper">
          <div className="dash-no-data">
            <div className="dashboard">
              <p className="qbank-title">QBANK DASHBOARD</p>
              <div className="no-data-prompt">
                <p>
                  Welcome to the Qbank Dashboard where you'll be able to track
                  your progress.
                </p>
              </div>
              <CircularProgress size={60} thickness={7} color="#95BF5E" />
            </div>
          </div>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    product: state.app ? state.app.product : null,
    loading: state.state.loading,
    currentState: state.currentState.state,
    stats: state.stats,
    tags: state.tags,
    isTrial: state.app && state.app.user && state.app.user.isTrial
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { changeState, createQuiz, updateDashboard },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/containers/Dashboard.js